"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeopleListCompleted = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const Formatters_1 = require("../../common/Formatters");
const hui_1 = require("@mit/hui");
const PersonDetailsDrawer_1 = __importDefault(require("../common/PersonDetailsDrawer"));
const PeopleListCompletedComponent = ({ peopleStore, covidNav, isLoading }) => {
    var _a;
    const [showPerson, setShowPerson] = (0, react_1.useState)(false);
    const [person, setPerson] = (0, react_1.useState)();
    const viewPersonClose = () => {
        setPerson(undefined);
        setShowPerson(false);
    };
    const showPersonInfo = (item) => {
        setShowPerson(true);
        setPerson(item);
    };
    const toTitleCase = (str) => {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };
    const columns = [
        {
            id: "name",
            name: "Name",
            sortable: true,
            formatter: (item) => { return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "clickable", onClick: () => { showPersonInfo(item); } }, { children: (0, jsx_runtime_1.jsx)("span", { children: item.name }) }))); },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Name"
            },
            filterable: true,
            filterOptions: {
                type: "textbox",
                onFilter: (item, value) => {
                    if (item.display_name.toLowerCase().indexOf(value.toLowerCase()) != -1)
                        return true;
                    return false;
                },
            }
        },
        {
            id: "mitId",
            name: "MIT ID",
            sortable: false,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "MIT ID"
            },
            filterable: false
        },
        {
            id: "gender",
            name: "Gender",
            formatter: (item) => { return toTitleCase(item.gender); },
            sortable: false,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Gender"
            },
            filterable: false
        },
        {
            id: "phoneNumber",
            name: "Phone",
            sortable: false,
            formatter: (item) => { return ((0, jsx_runtime_1.jsx)("a", Object.assign({ href: `tel:${item.phoneNumber}` }, { children: (0, Formatters_1.formatPhoneNumber)(item.phoneNumber) }))); },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Phone"
            },
            filterable: false
        },
        {
            id: "email",
            name: "Email",
            sortable: false,
            formatter: (item) => { return ((0, jsx_runtime_1.jsx)("a", Object.assign({ className: "table-email", href: `mailto:${item.email}` }, { children: item.email }))); },
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Email"
            },
            filterable: false
        },
        {
            id: "dateOfBirth",
            name: "Date of Birth",
            sortable: false,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Date of Birth"
            },
            filterable: false
        },
        {
            id: "testDate",
            name: "Collected",
            sortable: true,
            formatter: (item) => { return (0, Formatters_1.displayDateTimeLong)(item.testDate); },
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Collected"
            }
        },
        {
            id: "sampleId",
            name: "Sample ID",
            sortable: false,
            options: {
                demandPopin: true,
                minWidth: 600,
                popinText: "Sample ID"
            },
            filterable: false
        },
        {
            id: "exported",
            name: "Broad",
            sortable: true,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Broad"
            },
            filterable: false
        },
        {
            id: "result",
            name: "Result",
            sortable: true,
            options: {
                demandPopin: true,
                minWidth: 1000,
                popinText: "Result"
            }
        }
    ];
    const data = (_a = peopleStore.completedList) === null || _a === void 0 ? void 0 : _a.map((person, index) => {
        return Object.assign(Object.assign({}, person), { gender: person.gender ? person.gender : '-', phoneNumber: person.phoneNumber ? (0, Formatters_1.formatPhoneNumber)(person.phoneNumber) : '-', email: person.email ? person.email : '-', dateOfBirth: person.dateOfBirth ? (0, Formatters_1.displayDate)(person.dateOfBirth) : '-' });
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(hui_1.AdvancedTable, { columns: columns, items: data ? data : [], showExportButton: false, showFilterButton: true, isLoading: isLoading || covidNav.globalTableIsLoading, sortStateOptions: {
                    enabled: true,
                    key: 'covid-medical-people-list-complete'
                }, theme: "medical" }), (0, jsx_runtime_1.jsx)(PersonDetailsDrawer_1.default, { id: person === null || person === void 0 ? void 0 : person.mitId, show: showPerson, onClose: viewPersonClose })] }));
};
exports.PeopleListCompleted = (0, mobx_react_1.inject)('peopleStore', 'covidNav')((0, mobx_react_1.observer)(PeopleListCompletedComponent));
